<template>
  <v-carousel
    class="mt-4"
    height="500px"
    width="700px"
    v-model="carousel"
    hide-delimiters
    cycle
  >
    <v-carousel-item v-for="(item, index) in items" :key="index">
      <v-card class="mt-2 mb-4 white_darken" height="500px" max-width="700px">
        <v-card-text>
          <div class="container">
            <div class="row justify-content-end">
              <v-spacer> </v-spacer>
              <div class="col-6">{{ item.date }}</div>
            </div>
          </div>
          <p class="display-1 text--primary text-truncate">
            {{ item.title }}
          </p>
          <p style="color: #000">Type: {{ item.type }}</p>
          <div class="body-1 text--primary">
            <span class="font-weight-black">Reference Link:</span>
            <i> {{ item.link }} </i>
          </div>
          <div class="body-1 text--primary">
            <span class="font-weight-black">Source:</span> {{ item.source }}
          </div>
        </v-card-text>
        <div class="row justify-content-center">
          <div class="col-12">
            <v-btn
              class="blueblack--text ml-0 mt-5"
              outlined
              rounded
              small
              @click="selected = index"
            >
              Read More
            </v-btn>
          </div>
        </div>

        <v-expand-transition>
          <v-card
            v-if="selected === index"
            class="
              white
              transition-fast-in-fast-out
              v-card--reveal
              scroll-vertical
            "
            style="height: 52%;"
          >
            <v-card-text class="black--text pb-0">
              <p style="color: #000;" >{{ item.body }}</p>
            </v-card-text>
            <div class="row justify-content-center">
              <div class="col-12">
                <v-btn text color="orange accent-4" @click="selected = -1">
                  Close
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-expand-transition>
      </v-card>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  name: "LatestAnnouncement",
  async created() {
    await this.fetchLatestAnnouncementsPA();
  },
  computed: {
    ...mapFields("announcement", ["latestAnnouncements"]),
  },
  data: () => ({
    selected: -1,
    carousel: 0,
    items: [],
  }),
  methods: {
    ...mapActions("announcement", ["fetchLatestAnnouncementsPA"]),
  },
  watch: {
    latestAnnouncements: {
      immidate: true,
      handler(value) {
        if (value.length != 0) {
          value.map((announcement) => {
            this.items.push({
              title: announcement.message_en,
              body: announcement.message_en,
              source: announcement.source,
              type: announcement.type,
              link: announcement.reference,
            });
          });
        }
      },
    },
  },
};
</script>
<style>
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>